import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    card: css`
      .ant-card-actions {
        padding: 0px 16px;
      }
    `,

    list: css`
      border: 1px solid rgba(5, 5, 5, 0.06);
      border-radius: 10px;
      margin-bottom: 16px;
    `,

    leadSteps: {
      maxWidth: 700
    },

    leadCard: {
      width: '100%',
      maxWidth: 1200,

      borderRadius: 16,
      '.ant-card-head': {
        minHeight: 72,
        padding: 16,

        '.ant-card-head-title': {
          fontSize: 16
        }
      },
      '.ant-card-body': {
        padding: 16
      }
    },
    modal: {
      'ant-modal-content': {
        padding: 0
      },
      'ant-modal-body': {
        maxHeight: '80vh',
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    },

    selectWidth: {
      width: '50%'
    },

    customText: {
      maxWidth: '300px !important'
    }
  }
})
